module.exports = __webpack_public_path__ + "img/lanedens.d4c00bf5.svg";